import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { Experience, Information, Program, Title, Wrapper } from './TrainingProgram.elements';
import StaticCarouselGalleryTemplate from "@components/StaticCarouselGallery/StaticCarouselGallery";
import {getApiURL} from "../../constants";

export interface TrainingProgramProps {
    program: string;
    detail: string;
    experience: string;
    experienceGallery: string[];
}

const TrainingProgramTemplate: FC<TrainingProgramProps> = ({ program, detail, experience, experienceGallery }) => {
    const { t } = useTranslations();

    const fStr = program?.match(/width="\s*(\d+)"/);
    let result = program;
    if (fStr) {
        result = program.replace(fStr[0], " width='auto' ");
    }

    return (
        <>
            {experience && <Experience dangerouslySetInnerHTML={{ __html: experience }} />}
            {experienceGallery?.length > 0 && (
                <StaticCarouselGalleryTemplate
                    images={experienceGallery?.map((photo) => `${getApiURL()}/media/course/static-gallery/${photo}`)}
                />
            )}
            {(result || detail) && (
                <Wrapper>
                    {result && <Title>{t('training.program.title')}</Title>}
                    {result && <Program dangerouslySetInnerHTML={{ __html: result }} withBorder={!!detail} />}
                    {detail && <Title>{t('training.program.information')}</Title>}
                    {detail && <Information dangerouslySetInnerHTML={{ __html: detail }} />}
                </Wrapper>
            )}
        </>
    );
};

export default TrainingProgramTemplate;
